// src/design-system/Pill.tsx
import clsx from "clsx";
import type { ReactNode } from "react";

import type { Tone } from "./tone";

/** شارة حالة مضيئة: نقطة متوهجة + نص بلون الحالة. */
export function Pill({ tone = "mute", children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return (
    <span className={clsx("pill", className)} data-tone={tone}>
      <span className="dot" style={{ width: 6, height: 6 }} />
      {children}
    </span>
  );
}

/** شارة نصية بدون نقطة (وسوم صغيرة مثل: صرف / صيانة). */
export function Tag({ tone = "mute", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      data-tone={tone}
      className="inline-block rounded-full px-2.5 py-0.5 text-[11.5px]"
      style={{ background: "var(--bg)", color: "var(--fg)", border: "1px solid var(--fg)" }}
    >
      {children}
    </span>
  );
}

export function GlowDot({ tone = "ok", pulse = false, size = 7 }: { tone?: Tone; pulse?: boolean; size?: number }) {
  return <span className={clsx("dot", pulse && "dot-pulse")} data-tone={tone} style={{ width: size, height: size }} />;
}
